// packages
const { h, Component } = require("preact");
import { geoMercator, geoPath } from 'd3';

// components

// internal

class ByCategoryTitle extends Component {
  constructor() {
    super();

    this.state = {}
  }

  render() {
    const projection = geoMercator()
      .fitSize([60, 60], this.props.mapData);
    const path = geoPath(projection);
   
    return (
      <div class="bar-cell by-category-title">
        <div class="map">
          <svg
            width="60"
            height="60"
          >
            <g class="map">
              {this.props.mapData.features.map(d => (
                <path
                  d={path(d)}
                  fill={d.properties.category == this.props.tag ? "#333333" : "lightgray"}
                ></path>
              ))}
            </g>
          </svg>
        </div>
      </div>
    )
  }
}

export default ByCategoryTitle;